
import Vue from 'vue';
import { HeaderButtonData, HeaderButtonComputed, HeaderButtonProps } from './HeaderButton';
import { HeaderButtonChangeEvent } from '@owc-utils/Seamless/headerIntegrations.d';
import { HeaderEvents } from '@owc-utils/Seamless/headerEvents.enum';

export default Vue.extend<HeaderButtonData, {}, HeaderButtonComputed, HeaderButtonProps>({
  name: 'HeaderButton',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
    isIconSmall: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    badge: {
      type: [String, Number],
      required: false,
    },
    lightMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventIcon: null,
      eventLabel: null,
      eventBadge: null,
    };
  },
  mounted() {
    this.$el?.addEventListener(
      HeaderEvents.HEADER_ICON_CHANGE_EVENT,
      ({ detail }: CustomEvent<HeaderButtonChangeEvent>) => {
        if (detail.icon) {
          this.eventIcon = detail.icon;
        }
        if (detail.label) {
          this.eventLabel = detail.label;
        }
        if (detail.badge) {
          this.eventBadge = detail.badge;
        }
      },
    );
  },
  computed: {
    displayIcon() {
      return this.eventIcon || this.icon;
    },
    displayLabel() {
      return this.eventLabel || this.ariaLabel;
    },
    displayBadge() {
      return this.eventBadge || this.badge;
    },
    shouldDisplayBadge() {
      const counter = this.displayBadge;

      if (counter) {
        return Number(counter) >= 0;
      }

      return false;
    },
  },
});
